import { logException } from "@wss/error-tracking";
import { toError } from "@wss/error-tracking/utils";

export type OrderGuideData = {
  categories: string[];
  subordinateAccounts: {
    userId: string;
    categories: string[];
    company: string;
    name: string;
  }[];
};

const getOrderGuideData = async (
  itemNumber: string,
): Promise<OrderGuideData> => {
  const getOrderGuideDataEndpoint = `/api:orderguide/getorderguideinfo/?itemNumber=${itemNumber}`;

  try {
    const response = fetch(getOrderGuideDataEndpoint);
    const result = (await response).json<OrderGuideData>();
    return await result;
  } catch (e) {
    const error = new Error("Error in getOrderGuideData", {
      cause: toError(e),
    });

    await logException(error);

    return {
      categories: [],
      subordinateAccounts: [],
    };
  }
};

export default getOrderGuideData;
